<template>
  <!-- footer reutilizable con dos acciones (izquierda/derecha) -->
  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="start" class="completo">
        <ion-button
          class="completo"
          :color="leftColor"
          :expand="leftExpand"
          :fill="leftFill"
          :size="leftSize"
          :disabled="leftDisabled"
          @click="$emit('left-click')"
        >
          {{ leftText }}
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end" class="completo">
        <ion-button
          class="completo"
          :color="rightColor"
          :expand="rightExpand"
          :fill="rightFill"
          :size="rightSize"
          :disabled="rightDisabled"
          @click="$emit('right-click')"
        >
          {{ rightText }}
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FooterDualActions',
  emits: ['left-click', 'right-click'],
  props: {
    // texto de los botones
    leftText: { type: String, default: 'Cancelar' },
    rightText: { type: String, default: 'Aceptar' },
    // estilo y comportamiento
    leftColor: { type: String, default: 'danger' },
    rightColor: { type: String, default: 'success' },
    leftFill: { type: String, default: 'solid' },
    rightFill: { type: String, default: 'solid' },
    leftExpand: { type: String, default: 'block' },
    rightExpand: { type: String, default: 'block' },
    leftSize: { type: String, default: 'normal' },
    rightSize: { type: String, default: 'normal' },
    leftDisabled: { type: Boolean, default: false },
    rightDisabled: { type: Boolean, default: false }
  }
})
</script>

<style scoped lang="scss">
@import "@/theme/footer-styles.scss";
</style>